import moment from 'moment'
import { toISODate } from 'lib/dateUtils'

const keyboxPrefix = 'Nøkkelboks: '
const keyboxRegex = /^Nøkkelboks:\s?/
export const photographerKeyInstructionPrefix = 'Tilgang til objektet: '
export const photographerKeyInstructionRegex = /\s?Tilgang til objektet:\s?/

export function stateFromWebOrder(webOrder) {
  let pickUpKeys = (!!webOrder.pickUpKeys).toString()
  let pickUpKeysInstructions = webOrder.pickUpKeysInstructions

  if (
    webOrder.pickUpKeysInstructions &&
    webOrder.pickUpKeysInstructions.length
  ) {
    if (keyboxRegex.test(webOrder.pickUpKeysInstructions)) {
      pickUpKeys = 'keybox'
      pickUpKeysInstructions = pickUpKeysInstructions.replace(keyboxRegex, '')
    }
  } else if (
    webOrder.messageForPhotographer &&
    webOrder.messageForPhotographer.length
  ) {
    if (photographerKeyInstructionRegex.test(webOrder.messageForPhotographer)) {
      pickUpKeys = 'other'
    }
  }

  return {
    bundleId: webOrder.bundleId,
    products: webOrder.selectedProducts || [],
    customProfile: webOrder.customProfile || '',
    pickUpKeys,
    pickUpKeysInstructions,
    expressDelivery: webOrder.expressDelivery,
    premiumService: webOrder.premiumService,
    estateAddressDoorbell: webOrder.estateAddressDoorbell,
    additionalEstateAddressInfo: webOrder.additionalEstateAddressInfo,
    messageForPhotographer: webOrder.messageForPhotographer,
    messageForCustomerService: webOrder.messageForCustomerService,
    reservedBooking: webOrder.reservedBooking,
    preferredPhotographer: webOrder.preferredPhotographer,
    preferredStylist: webOrder.preferredStylist,
    preferredResourceDate: webOrder.preferredResourceDate
      ? moment(webOrder.preferredResourceDate)
      : null,
    preferredResourcePriority: webOrder.preferredResourcePriority,
    invoiceType: webOrder.sendInvoiceByEmail ? 'email' : 'paper',
    invoiceRecipient: webOrder.invoiceRecipient,
  }
}

export function webOrderInputFromProductSelection(productSelection) {
  // null values disappear before hitting GraphQL, so empty strings must be returned
  // in order to "disable" a property.
  return {
    bundleId: productSelection.bundleId || '',
    products: productSelection.products.map(JSON.stringify),
    pickUpKeys: productSelection.pickUpKeys === 'true',
    pickUpKeysInstructions:
      productSelection.pickUpKeys === 'keybox'
        ? `${keyboxPrefix}${productSelection.pickUpKeysInstructions}`
        : '',
    expressDelivery: !!productSelection.expressDelivery,
    premiumService: !!productSelection.premiumService,
    estateAddressDoorbell: productSelection.estateAddressDoorbell || '',
    additionalEstateAddressInfo:
      productSelection.additionalEstateAddressInfo || '',
    messageForPhotographer: productSelection.messageForPhotographer || '',
    messageForCustomerService: productSelection.messageForCustomerService || '',
    reservedBookingId:
      productSelection.reservedBooking && productSelection.reservedBooking.id
        ? productSelection.reservedBooking.id
        : '',
    preferredPhotographer: productSelection.preferredPhotographer || '',
    preferredStylist: productSelection.preferredStylist || '',
    preferredResourceDate: productSelection.preferredResourceDate
      ? toISODate(productSelection.preferredResourceDate)
      : null, // Cant be empty string
    preferredResourcePriority: productSelection.preferredResourcePriority, // Cant be empty string
    invoiceType: productSelection.invoiceType || '',
    invoiceRecipient: productSelection.invoiceRecipient
      ? {
        id: productSelection.invoiceRecipient.id || '',
        name: productSelection.invoiceRecipient.name || '',
        email: productSelection.invoiceRecipient.email || '',
        streetAddress: productSelection.invoiceRecipient.streetAddress || '',
        postalCode: productSelection.invoiceRecipient.postalCode || '',
        postalArea: productSelection.invoiceRecipient.postalArea || '',
        recipientType: productSelection.invoiceRecipient.recipientType || '',
        organizationNumber: productSelection.invoiceRecipient.organizationNumber || '',
      }
      : null,
  }
}

export function getRedirectStep(webOrder) {
  const {
    estate,
    segment,
    estateSellers,
    floors,
    m2,
    address,
    floorNumber,
  } = webOrder

  const validEstateSellers =
    estateSellers &&
    estateSellers.length &&
    estateSellers.every(seller => !!seller.name && !!seller.phone && !!seller.email)

  // Estate exists, no redirect
  if (estate) {
    return ''
  }

  const floorNumberIsRequired = segment && segment.type === 'apartment'

  if (!address || !address.street || !address.location || !address.location.lat || !address.location.lon) {
    return 'identifiser-eiendom'
  } else if (!segment) {
    return 'velg-segment'
  } else if (!m2 || !floors || (floorNumberIsRequired && !floorNumber) || !validEstateSellers) {
    return 'oppdragsinformasjon'
  }

  return '';
}
